/*
 * Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { CommonModule } from '@angular/common';
import { Component, DoCheck, Input } from '@angular/core';
import { IconComponent } from '../../icon/icon.component';

@Component({
  selector: 'ods-button-toggle',
  imports: [CommonModule, IconComponent],
  template: `<button
    [attr.data-test-id]="dataTestId"
    class="flex h-full cursor-pointer items-center gap-1 px-3 py-1.5 outline-hidden hover:bg-neutral-300 focus-visible:bg-neutral-300 dark:hover:bg-neutral-600 dark:focus-visible:bg-neutral-600"
    [ngClass]="{
      'bg-neutral-200 font-bold hover:bg-neutral-200 focus-visible:bg-neutral-200 dark:bg-neutral-900 dark:hover:bg-neutral-800 dark:focus-visible:bg-neutral-800':
        isChecked,
    }"
    [value]="value"
    (click)="onClick()"
  >
    @if (isChecked) {
      <ods-icon data-test-class="toggle-check-icon" name="check" [config]="{ size: 'small', label: 'ausgewählt' }" />
    }
    <p class="text-sm">{{ label }}</p>
  </button>`,
})
export class ButtonToggleComponent implements DoCheck {
  @Input({ required: true }) label!: string;
  @Input({ required: true }) value!: string;
  @Input() dataTestId: string;
  @Input() onClick: () => void;
  @Input() isSelected: (value: string) => boolean = () => false;

  isChecked: boolean = false;

  ngDoCheck(): void {
    this.isChecked = this.isSelected(this.value);
  }
}
